import { render, staticRenderFns } from "./RescopeDialog.vue?vue&type=template&id=5962f694"
import script from "./RescopeDialog.vue?vue&type=script&lang=js"
export * from "./RescopeDialog.vue?vue&type=script&lang=js"
import style0 from "./RescopeDialog.vue?vue&type=style&index=0&id=5962f694&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports